import { Box } from "@mui/material";

export const ItemPropertyValue = ({ value }) => {
    const isEmpty = value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0);
    if (isEmpty) {
        return <Box component="span" sx={{ color: 'text.secondary' }}>—</Box>;
    }
    return (
        <Box component="span">{Array.isArray(value) ? value.join(', ') : String(value)}</Box>
    );
}
